var map = {
	"./featured-title.de-CH.json": 1123,
	"./featured-title.de-DE.json": 1124,
	"./featured-title.en-CA.json": 1125,
	"./featured-title.en-GB.json": 1126,
	"./featured-title.en-IN.json": 1127,
	"./featured-title.en-ME.json": 1128,
	"./featured-title.en-US.json": 1129,
	"./featured-title.es-EM.json": 1130,
	"./featured-title.es-ES.json": 1131,
	"./featured-title.fr-BE.json": 1132,
	"./featured-title.fr-CA.json": 1133,
	"./featured-title.fr-CH.json": 1134,
	"./featured-title.nl-BE.json": 1135,
	"./featured-title.nl-NL.json": 1136,
	"./featured-title.pl-PL.json": 1137,
	"./featured-title.pt-BR.json": 1138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1122;